import React from 'react';
import { Field, FieldRenderProps, useForm, FieldProps } from 'react-final-form';
import AutoSave from '../AutoSave';
import DateInput from '../../../components/Inputs/Date';
import { IndicatorStateOptions } from '../../../components/Indicator';
// FIXME making custom props optional until this is resolved:
// https://github.com/final-form/react-final-form/issues/175
type DateInputMetaProps = {
  invalid?: boolean;
  error?: string;
  initial?: any;
  disabled?: boolean;
  submitting?: boolean;
  submitFailed?: boolean;
  submitSucceeded?: boolean;
  dirtySinceLastSubmit?: boolean;
  dirty?: boolean;
};

const getIndicatorState = (
  props: DateInputMetaProps,
): IndicatorStateOptions => {
  let state: IndicatorStateOptions = 'new';
  if (props.initial) state = 'complete';
  if (props.error || props.invalid) state = 'error';
  if (props.submitting && props.dirtySinceLastSubmit !== props.dirty)
    state = 'loading';
  return state;
};

interface DateInputFieldComponentProps
  extends FieldRenderProps<any, HTMLInputElement> {
  text?: string;
  informationText?: string[];
  enabled?: boolean;
  supportingLink?: React.MouseEventHandler;
  handleSubmit?: () => void;
}
const DateInputFieldComponent = ({
  input,
  meta,
  handleSubmit,
  enabled,
  ...rest
}: DateInputFieldComponentProps) => {
  return (
    <AutoSave
      name={input.name}
      handleSubmit={handleSubmit ? handleSubmit : () => {}}>
      <DateInput
        {...input}
        {...meta}
        enabled={enabled}
        // disabled={meta.submitting}
        indicatorState={getIndicatorState(meta)}
        {...rest}
      />
    </AutoSave>
  );
};

export interface DateInputFieldProps
  extends FieldProps<any, FieldRenderProps<any>> {
  text?: string;
  informationText?: string[];
  supportingLink?: React.MouseEventHandler;
  enabled?: boolean;
}

const DateField = (props: DateInputFieldProps) => {
  const form = useForm();
  const required = !(props.enabled === false) && props.required;
  const { name, ...otherProps } = props;
  return (
    <Field
      name={name}
      component={DateInputFieldComponent}
      handleSubmit={form.submit}
      {...otherProps}
      required={required}
      validate={required ? props.validate : undefined}
    />
  );
};

export default DateField;
